{
    "IncludeendedonholdLabel": "Beendete Warteschleife einbeziehen:",
    "UnreturnedCalls_SectionHeader": "Nicht beantwortete Anrufe",
    "UnreturnedCalls_SectionPara": "Sie können auswählen, ob Anrufe, die in der Warteschleife beendet wurden, in den Berichten „Nicht zurückgegebene verlorene Anrufe“ sowie in der Statistik „Nicht zurückgegebene Anrufe“ als abgebrochen gelten.",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Entflohene einbeziehen:"
}